import ExternalObjectInList from './ExternalObjectInList';

export default ExternalObjectInList;